import {
  QCTaskDefinition,
  TaskDefinitionExecutionNamedStatus,
  TaskDefinitionStatus,
} from '@dynamika-shared/types/qcTaskDefinitions';
import { AlertIcon, Attention } from '@dynamika-shared/ui/icons';
import { format } from 'date-fns';
import { Dot } from '@dynamika-shared/ui/Dot/Dot';

type ReadingTaskDataCheckProps = {
  executionStatus: QCTaskDefinition['executionStatus'];
  status: QCTaskDefinition['status'];
  lastExecutionDate: QCTaskDefinition['lastExecutionDate'];
};
export const ReadingTaskDataCheck = ({
  executionStatus,
  status,
  lastExecutionDate,
}: ReadingTaskDataCheckProps) => {
  if (
    executionStatus &&
    executionStatus !== TaskDefinitionExecutionNamedStatus.IN_PROGRESS
  ) {
    if (!lastExecutionDate) {
      return null;
    }
    return (
      <div className='flex text-1424 items-center'>
        <span className='whitespace-nowrap '>
          {format(new Date(lastExecutionDate), 'dd-MMM-yyyy')}
        </span>
        <div>
          <Dot className='!mx-[0.1em] text-[18px]' />
        </div>
        <span className='text-dimGray '>
          {format(new Date(lastExecutionDate), 'HH:mm:ss')}
        </span>
      </div>
    );
  }
  if (
    status === TaskDefinitionStatus.READY &&
    executionStatus !== TaskDefinitionExecutionNamedStatus.IN_PROGRESS
  ) {
    return (
      <div className='flex gap-1 text-dimGray text-1424 items-center'>
        <Attention className='text-yellowGreen rotate-180' />
        All data collected
      </div>
    );
  }
  if (
    status === TaskDefinitionStatus.NOT_READY &&
    executionStatus !== TaskDefinitionExecutionNamedStatus.IN_PROGRESS
  ) {
    return (
      <div className='flex gap-1 text-dimGray text-1424 items-center'>
        <AlertIcon className='h-2 w-2 text-vividTangelo' /> Not all data
        collected
      </div>
    );
  }
  return null;
};
